import { RolesConfig } from "@dashboard-v3/api/src/types/roles";
import { PermissionName } from "@dashboard-v3/api/src/schemas/roles";
import { PermissionGroup, RoleItem } from "./types";
import { UserRole } from "@dashboard-v3/api";
import dayjs from "dayjs";

// OWNER is not persisted: it has no restrictions, so its permissions never
// need to be checked. It is shown as a fixed, non-editable "Unrestricted" row.
const OWNER_ROW: RoleItem = {
  role: "OWNER",
  name: "userRole.OWNER",
  canEdit: false,
  enabled: 0,
  total: 0,
  updatedAt: "common:notApplicable",
  permissions: [],
};

export function toRoleRow(data: RolesConfig): RoleItem[] {
  const rows = Object.entries(data)
    .filter(([role]) => role !== "OWNER")
    .map(([role, values]) => {
      const permissionsEntries = Object.entries(values.permissions);

      return {
        role: role as UserRole,
        name: `userRole.${role}`,
        canEdit: role !== "OWNER",
        total: permissionsEntries.length,
        enabled: permissionsEntries.filter(([_, value]) => value).length,
        updatedAt: values.updatedAt ? dayjs(values.updatedAt).fromNow() : "N/A",
        permissions: permissionsEntries.map(([name, value]) => ({
          name: name as PermissionName,
          value,
          label: `rolePermissionLabel.${name}`,
          description: `rolePermissionDesc.${name}`,
          group: permissionsByGroup[name],
        })),
      };
    });

  return [OWNER_ROW, ...rows];
}

const permissionsByGroup: Record<PermissionName, PermissionGroup> = {
  mxheroAppTempHoldAdminView: "MXHERO_APP",
  mxheroAppApprovalsAdminView: "MXHERO_APP",
  mxheroAppSharesAdminView: "MXHERO_APP",
};
